import { AxiosRequestConfig } from "axios";
import { endpoints } from "config";
import { getFileFromURL } from "helpers/getFileFromURL";
import { parseCamelCase } from "helpers/parseCamelCase";
import { downloadUploadedFile } from "pages/AddBulk";
import { Dispatch, useEffect } from "react";
import { useSelector } from "react-redux";
import { CustomRowCellColumns, CustomRowCellData } from "reducers/listPage";
import { selectSubmitResponse, setSubmitResponseErrors } from "reducers/submitResponse";
import ToastMessage, { toastConfig } from "helpers/ToastMessage/ToastMessage";
import { toast } from "react-toastify";

export const documentsFilesDownloader = (
  dispatch: React.Dispatch<any>,
  selectedDataIDs: number[] | null,
  documentName: string,
  additionalDataIDs?: any,
  nestedListPageUrl?: string,
  parentSelectedIdName?: string,
  parentSelectedId?: number
) => {
  const parsedData =
    additionalDataIDs && Array.isArray(additionalDataIDs) && additionalDataIDs.length > 0
      ? additionalDataIDs.map((item) => {
          if (
            typeof item === "object" &&
            item.hasOwnProperty("id") &&
            item.hasOwnProperty("documents__DocumentVersion")
          ) {
            return {
              id: item.id,
              versionNumber: item.documents__DocumentVersion,
            };
          } else {
            return item;
          }
        })
      : additionalDataIDs;

  const isMulti = Array.isArray(parsedData) && parsedData.length > 1 ? true : false;

  getFileTemplate(
    nestedListPageUrl ?? endpoints.documents.download,
    parsedData,
    isMulti,
    dispatch,
    documentName,
    parentSelectedIdName,
    parentSelectedId
  );
};

export const getFileTemplate = async (
  url: string,
  payload: any,
  isMulti: boolean = false,
  dispatch?: Dispatch<any>,
  documentName?: string,
  parentSelectedIdName?: string,
  parentSelectedId?: number
) => {
  let config: AxiosRequestConfig = {
    params: { ids: payload },
  };

  if (parentSelectedIdName && parentSelectedId) {
    let tempParams = { ...config.params };
    tempParams[parentSelectedIdName] = parentSelectedId;
    config.params = tempParams;
  }

  getFileFromURL(
    url,
    documentName ?? "downloaded_file",
    config,
    "post",
    isMulti ? "arraybuffer" : "blob"
  ) // "arraybuffer" for zip files
    .then((file: any) => {
      downloadUploadedFile(file, file.type, file.name ?? documentName ?? `downloaded_file`);

      if (dispatch) {
        dispatch(setSubmitResponseErrors({ submitResponseErrors: null }));
      }
    })
    .catch((err) => {
      const error: any = err;

      if (
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        Array.isArray(error.response.data.errors) &&
        error.response.data.errors.length > 0
      ) {
        const unparsedErrors = error.response.data.errors;

        let parsedErrors: any = {};

        unparsedErrors.forEach((item: any) => {
          if (
            typeof item === "object" &&
            item.hasOwnProperty("fieldName") &&
            item.hasOwnProperty("messageCode")
          ) {
            const parsedFieldName = parseCamelCase(item.fieldName)
              .split("_")
              .join(" ")
              .replace("_", "")
              .replaceAll(/  +/g, " ")
              .trim();
            const parsedMessageCode = item.messageCode
              .split("_")
              .join(" ")
              .replace("_", "")
              .replaceAll(/  +/g, " ")
              .trim();
            parsedErrors[parsedFieldName] = parsedMessageCode;
          }
        });

        if (Object.keys(parsedErrors).length > 0) {
          // helpers.setErrors(parsedErrors);

          if (dispatch) {
            dispatch(setSubmitResponseErrors({ submitResponseErrors: parsedErrors }));
          }
        }
      } else {
        if (dispatch) {
          dispatch(setSubmitResponseErrors({ submitResponseErrors: true }));
        }
      }
    });
};

export const documentsDownloadSingleDoc = (
  data: any,
  customRowCellData: CustomRowCellData | null,
  customRowCellColumn: CustomRowCellColumns,
  getOrPost: "get" | "post",
  dispatch: Dispatch<any>,
  nestedListPageUrl?: string,
  parentSelectedIdName?: string,
  parentSelectedId?: number,
  fileExtensionColumnName?: string
) => {
  let newVersionNumber: string | null = null;

  if (
    customRowCellData &&
    customRowCellData[customRowCellColumn] &&
    Array.isArray(customRowCellData[customRowCellColumn]) &&
    data &&
    data.documents__Id
  ) {
    const matches = customRowCellData[customRowCellColumn].filter(
      (item: any) => item.id && `${item.id}` === `${data.documents__Id}`
    );

    if (
      matches &&
      Array.isArray(matches) &&
      matches.length === 1 &&
      typeof matches[0] == "object" &&
      matches[0].hasOwnProperty("documents__DocumentVersion")
    ) {
      newVersionNumber = `${matches[0].documents__DocumentVersion}`;
    }
  }

  const parsedData =
    data && data.documents__DocumentVersion && data.documents__Id
      ? [
          {
            id: data.documents__Id,
            versionNumber: newVersionNumber ? newVersionNumber : data.documents__DocumentVersion,
          },
        ]
      : null;

  let documentName =
    data && data.documents__Name
      ? data.documents__Name
      : data && data.documents__Id
        ? `Document ${data.documents__Id}`
        : "Document";

  if (fileExtensionColumnName && data[fileExtensionColumnName]) {
    documentName += data[fileExtensionColumnName];
  }

  console.log("documentName: ", documentName);

  if (parsedData) {
    getFileTemplate(
      nestedListPageUrl ?? endpoints.documents.download,
      parsedData,
      false, // Only ever one file being downloaded using this button
      dispatch,
      documentName,
      parentSelectedIdName,
      parentSelectedId
    );
  }
};
